import { render } from "./LoadingPostOutline.vue?vue&type=template&id=3add12f6&ts=true"
import script from "./LoadingPostOutline.vue?vue&type=script&lang=ts"
export * from "./LoadingPostOutline.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__